import React from 'react';
import PropTypes from 'prop-types';

// Components
import Link from '../../Link/Link';

const TwitterButton = ({ postLink, title }) => (
  <Link
    className="social-button-link"
    target="_blank"
    rel="noopener noreferrer"
    href={`https://twitter.com/intent/tweet?url=${postLink}/&text=${title}`}
    title={title}
  >
    <div className="social-button-icon flex-center">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM16.7715 9.5528C16.7762 9.65839 16.7787 9.76453 16.7787 9.87128C16.7787 13.1246 14.3024 16.876 9.77393 16.876C8.38361 16.876 7.08954 16.4685 6 15.77C6.19257 15.7927 6.38855 15.8044 6.58728 15.8044C7.74072 15.8044 8.80231 15.4108 9.6449 14.7505C8.56757 14.7306 7.65833 14.0188 7.34503 13.0407C7.49536 13.0694 7.6496 13.0848 7.80823 13.0848C8.03278 13.0848 8.25025 13.0547 8.45685 12.9985C7.33063 12.7724 6.482 11.7774 6.482 10.5845C6.482 10.5741 6.482 10.5638 6.48218 10.5535C6.81415 10.7379 7.19373 10.8487 7.59729 10.8615C6.93671 10.4199 6.50208 9.66639 6.50208 8.81227C6.50208 8.3611 6.62348 7.93819 6.83539 7.57454C8.04968 9.06404 9.86371 10.0442 11.9099 10.1469C11.8679 9.96669 11.8461 9.77877 11.8461 9.58583C11.8461 8.22621 12.9484 7.12392 14.3081 7.12392C15.0162 7.12392 15.656 7.42293 16.1051 7.90139C16.666 7.79098 17.1928 7.58608 17.6685 7.30398C17.4847 7.87885 17.0943 8.36133 16.586 8.66602C17.0841 8.60651 17.5585 8.47413 18 8.27832C17.6699 8.77203 17.2525 9.20569 16.7715 9.5528Z"
          fill="#1EA1F2"
        />
      </svg>
    </div>
  </Link>
);

TwitterButton.propTypes = {
  postLink: '',
};

TwitterButton.propTypes = {
  title: PropTypes.string.isRequired,
  postLink: PropTypes.string.isRequired,
};

export default TwitterButton;
